import apiClient from '../client'

export const dashboardService = {
  getOverview: async () => {
    const response = await apiClient.get('/dashboard/overview')
    return response.data
  },

  getRecentActivity: async (limit = 10) => {
    const response = await apiClient.get(`/dashboard/recent-activity?limit=${limit}`)
    return response.data
  },

  getComplianceStats: async () => {
    const response = await apiClient.get('/dashboard/compliance-stats')
    return response.data
  },

  getIssuesBySeverity: async () => {
    const response = await apiClient.get('/dashboard/issues-by-severity')
    return response.data
  },

  getDashboardData: async (period = 30) => {
    const response = await apiClient.get('/dashboard', { params: { period } })
    return response.data
  },
}
